import {
  call,
  put,
  all,
  spawn,
  takeLatest,
  debounce,
  takeEvery,
} from 'redux-saga/effects';
import request from '../../utils/request';

import {
  GET_SETTLEMENT_HOLIDAYS_URL,
  GET_UNSETTLED_AMOUNT_URL,
} from '../../utils/constants';

import { showToast } from '../Toast/actions';
import {
  disableLoaderAction,
  saveSettlementsHolidaysAction,
  updateUnsettledAmount,
  updateEligibleFunds,
} from './actions';

import {
  SEARCH_SETTLEMENTS,
  GET_SETTLEMENT_HOLIDAYS,
  SEARCH_ON_DEMAND_SETTLEMENTS_URL,
  GET_ON_DEMAND_SETTLEMENT_STATUS,
  GET_ON_DEMAND_SETTLEMENT_STATUS_URL,
  REQUEST_ON_DEMAND_ACTIVATION,
  GET_ON_DEMAND_MAX_DAILY_LIMIT,
  GET_ON_DEMAND_MAX_DAILY_LIMIT_URL,
  CREATE_ON_DEMAND_SETTLEMENTS,
  CREATE_ON_DEMAND_SETTLEMENTS_URL,
  GET_UNSETTLED_AMOUNT,
  GET_ELIGIBLE_FUNDS,
  GET_ELIGIBLE_FUNDS_URL,
  GET_SETTLEMENT_RATES,
  GET_SETTLEMENT_RATES_URL,
  GET_FREE_TRIAL_STATUS,
  EXTEND_FREE_TRIAL,
  GET_FREE_TRIAL_NUDGE,
  UPDATE_FREE_TRIAL_STATUS,
  GET_ON_DEMAND_SETTLE_NOW_DATA_URL,
  GET_ON_DEMAND_SETTLE_NOW_DATA,
  GET_ON_DEMAND_CONSTANTS_URL,
  GET_FREE_TRIAL_CONSTANTS,
} from './constants';
import {
  EXTEND_FREE_TRIAL_URL,
  GET_FREE_TRIAL_NUDGE_URL,
  GET_MERCHANT_CREDITS_URL,
  UPDATE_FREE_TRIAL_STATUS_URL,
  ACTIVATE_ON_DEMAND_SETTLEMENTS_INSTANTLY_URL,
} from '../../constants/url';

export function* searchSettlements({ data }) {
  try {
    const { options: reqOptions, cb, settlementType } = data;
    const { url, method } = SEARCH_ON_DEMAND_SETTLEMENTS_URL;

    let updatedReqOptions = { ...reqOptions };
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions || {},
    };
    const response = yield call(request, url, options);
    cb(response);
  } catch (err) {
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* getSettlementHolidays({ data: { settlementType } }) {
  try {
    const { url, method } = GET_SETTLEMENT_HOLIDAYS_URL;

    let queryString = {};

    if (settlementType === 'offline') {
      queryString = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString,
    };
    const response = yield call(request, url, options);
    yield put(saveSettlementsHolidaysAction(response));
    // eslint-disable-next-line no-empty
  } catch (err) {}
}

export function* getOnDemandSettlementStatus({ data: { cb, settlementType } }) {
  const result = {};
  try {
    const odResponse = yield call(
      request,
      GET_ON_DEMAND_SETTLEMENT_STATUS_URL.url,
    );

    let updatedReqOptions = { productType: 'OD_SETTLEMENT' };
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    result.OD = odResponse;

    try {
      const { url, method } = GET_MERCHANT_CREDITS_URL;
      const creditsResponse = yield call(request, url, {
        method,
        queryString: updatedReqOptions,
      });
      result.FREE_TRIAL = creditsResponse;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('OnDemand-onDemandStatus', e);
    }

    if (cb) cb(result);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('OnDemand-onDemandStatus', err);
    // yield put(showToast(err));
  }
}

export function* requestOnDemandActivation({ data: { cb, settlementType } }) {
  try {
    const { url, method } = ACTIVATE_ON_DEMAND_SETTLEMENTS_INSTANTLY_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* getOnDemandMaxDailyLimit({
  data: { cb, errorCb, settlementType },
}) {
  try {
    const { url, method } = GET_ON_DEMAND_MAX_DAILY_LIMIT_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
    if (errorCb) errorCb();
  }
}

export function* getSettlementRates({ data: { cb, settlementType } }) {
  try {
    const { url, method } = GET_SETTLEMENT_RATES_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* createOnDemandSettlements({
  data: { data, cb, errorCb, settlementType },
}) {
  try {
    const { url, method } = CREATE_ON_DEMAND_SETTLEMENTS_URL;

    let updatedData = { ...data };

    if (settlementType === 'offline') {
      updatedData = { ...updatedData, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      body: JSON.stringify(updatedData),
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    if (errorCb) errorCb();
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* getUnsettledAmount({ data: { settlementType } }) {
  try {
    const { url, method } = GET_UNSETTLED_AMOUNT_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    yield put(updateUnsettledAmount(response));
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* getEligibleFunds({
  data: { queryString, cb, errorCb, settlementType },
}) {
  try {
    const { url, method } = GET_ELIGIBLE_FUNDS_URL;

    let updatedReqOptions = { ...queryString };
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    yield put(updateEligibleFunds(response));
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
    if (errorCb) errorCb();
  }
}

export function* getFreeTrialStatus({ data: { cb, errorCb, settlementType } }) {
  try {
    const { url, method } = GET_MERCHANT_CREDITS_URL;

    let updatedReqOptions = { productType: 'OD_SETTLEMENT' };
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const response = yield call(request, url, {
      method,
      queryString: updatedReqOptions,
    });
    if (cb) cb(response);
    // eslint-disable-next-line no-empty
  } catch (e) {
    if (errorCb) errorCb();
  }
}

export function* extendFreeTrial({ data: { cb, settlementType } }) {
  try {
    const { url, method } = EXTEND_FREE_TRIAL_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const response = yield call(request, url, {
      method,
      queryString: updatedReqOptions,
    });
    cb(response);
  } catch (err) {
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* updateFreeTrialStatus({ data: { data, cb, settlementType } }) {
  try {
    const { url, method } = UPDATE_FREE_TRIAL_STATUS_URL;

    let updatedData = { ...data };

    if (settlementType === 'offline') {
      updatedData = { ...updatedData, tenant: 'op' };
    }

    const response = yield call(request, url, {
      method,
      body: JSON.stringify(updatedData),
    });
    cb(response);
  } catch (err) {
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* getFreeTrialNudge({ data: { cb, settlementType } }) {
  try {
    const { url, method } = GET_FREE_TRIAL_NUDGE_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const response = yield call(request, url, {
      method,
      queryString: updatedReqOptions,
    });
    cb(response);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* getFreeTrialConstants({ data: { cb, settlementType } }) {
  try {
    const { url, method } = GET_ON_DEMAND_CONSTANTS_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const response = yield call(request, url, {
      method,
      queryString: updatedReqOptions,
    });
    cb(response);
  } catch (err) {
    // yield put(showToast(err));
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* getOnDemandSettleNowData({ data }) {
  const {
    settleNowDetails,
    cb,
    setIsLoading,
    settlementType,
  } = data.settleNowObj;
  try {
    const { url, method } = GET_ON_DEMAND_SETTLE_NOW_DATA_URL;

    let updatedReqOptions = { ...settleNowDetails };
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    setIsLoading(true);
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
  } finally {
    setIsLoading(false);
  }
}

export function* getOnDemandSettleNowDataSaga() {
  yield debounce(1000, GET_ON_DEMAND_SETTLE_NOW_DATA, getOnDemandSettleNowData);
}

export function* searchSettlementsSaga() {
  yield takeLatest(SEARCH_SETTLEMENTS, searchSettlements);
}

export function* getSettlementHolidaysSaga() {
  yield takeLatest(GET_SETTLEMENT_HOLIDAYS, getSettlementHolidays);
}

export function* getOnDemandSettlementStatusSaga() {
  yield takeEvery(GET_ON_DEMAND_SETTLEMENT_STATUS, getOnDemandSettlementStatus);
}

export function* requestOnDemandActivationSaga() {
  yield takeLatest(REQUEST_ON_DEMAND_ACTIVATION, requestOnDemandActivation);
}

export function* getOnDemandMaxDailyLimitSaga() {
  yield takeLatest(GET_ON_DEMAND_MAX_DAILY_LIMIT, getOnDemandMaxDailyLimit);
}

export function* createOnDemandSettlementsSaga() {
  yield takeLatest(CREATE_ON_DEMAND_SETTLEMENTS, createOnDemandSettlements);
}

export function* getUnsettledAmountSaga() {
  yield takeLatest(GET_UNSETTLED_AMOUNT, getUnsettledAmount);
}

export function* getEligibleFundsSaga() {
  yield takeLatest(GET_ELIGIBLE_FUNDS, getEligibleFunds);
}

export function* getSettlementRatesSaga() {
  yield takeLatest(GET_SETTLEMENT_RATES, getSettlementRates);
}

export function* getFreeTrialStatusSaga() {
  yield takeLatest(GET_FREE_TRIAL_STATUS, getFreeTrialStatus);
}

export function* extendFreeTrialSaga() {
  yield takeLatest(EXTEND_FREE_TRIAL, extendFreeTrial);
}

export function* getFreeTrialNudgeSaga() {
  yield takeLatest(GET_FREE_TRIAL_NUDGE, getFreeTrialNudge);
}

export function* updateFreeTrialStatusSaga() {
  yield takeLatest(UPDATE_FREE_TRIAL_STATUS, updateFreeTrialStatus);
}

export function* getFreeTrialConstantsSaga() {
  yield takeLatest(GET_FREE_TRIAL_CONSTANTS, getFreeTrialConstants);
}

// Individual exports for testing
export default function* onDemandSettlementsSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    searchSettlementsSaga,
    getSettlementHolidaysSaga,
    getOnDemandSettlementStatusSaga,
    requestOnDemandActivationSaga,
    getOnDemandMaxDailyLimitSaga,
    createOnDemandSettlementsSaga,
    getUnsettledAmountSaga,
    getEligibleFundsSaga,
    getSettlementRatesSaga,
    getFreeTrialStatusSaga,
    extendFreeTrialSaga,
    getFreeTrialNudgeSaga,
    updateFreeTrialStatusSaga,
    getOnDemandSettleNowDataSaga,
    getFreeTrialConstantsSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
